import type { serializeError } from '@w/utils'

// The throw site (stack) is what a reader needs first; the React tree
// (componentStack) is the longest field and the least specific, so it goes last.
const FIELD_ORDER = [
  'message',
  'type',
  'code',
  'status',
  'statusCode',
  'stack',
  'cause',
  'details',
  'componentStack',
]

export function orderedErrorEntries(value: ReturnType<typeof serializeError>) {
  const rank = (key: string) => {
    const index = FIELD_ORDER.indexOf(key)
    return index === -1 ? FIELD_ORDER.length : index
  }
  return Object.entries(value).toSorted(([a], [b]) => rank(a) - rank(b))
}
